import { render, staticRenderFns } from "./AdditionalMealsShiftTabs.vue?vue&type=template&id=51ba0b55&scoped=true"
import script from "./AdditionalMealsShiftTabs.vue?vue&type=script&lang=js"
export * from "./AdditionalMealsShiftTabs.vue?vue&type=script&lang=js"
import style0 from "./AdditionalMealsShiftTabs.vue?vue&type=style&index=0&id=51ba0b55&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ba0b55",
  null
  
)

export default component.exports